<template>
	<div class="form-input">
		<!-- Text block w/ label -->
		<div class='input-block'>
			<input
				:id="_uid"
				ref="item"
				:name="name"
				v-model="value"
				@input="update()"
				:disabled="disabled"
				:checked="value"
				type="checkbox"
			required>
			<label :for="_uid" v-if='title.length > 0' >{{title}}</label>
		</div>
	</div>
</template>

<script>

export default {
	name: "FormCheckbox",
	props: {
		value: {
			default: false
		},
		required: {
			default: false
		},
		disabled: {
			default: false
		},
		title: {
			default: ""
		},
		name: {
			default: "input"
		},
		hint: {
			default: ""
		}
	},
	methods: {
		update() {
			this.$emit('input', this.$refs.item.checked);
		}
	}
};
</script>

<style scoped lang="scss">
	.input-block{
		position: relative;
		color: #919eab;
		cursor: text;
		padding-left: 25px;
	}
	label{
		width: 100%;
		margin-bottom: 5px;
		font-family: 'proximanova-bold';
		line-height: 30px;
		margin-left: 10px;
	}
	input{
		position: absolute;
		left: 0px;
		z-index: 20;
		display: block;
		margin: 0;
		height: 26px;
		width: 26px;
	}
	input:focus{
		outline: 0px;
	}
</style>
